import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import reelstate from "../../Assets/Projects/reelstate.png";
import fashionecomerce from "../../Assets/Projects/fashionecomerce.png";

const mernecommerce =
  "https://placehold.co/600x400/1a1a2e/white?text=MERN+E-Commerce";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={reelstate}
              isBlog={false}
              title="ReelState"
              description="A web app that reimagines real estate browsing through short-form video, presenting property listings in a TikTok/Reels-style format with key characteristics and location info. Built to make property discovery more engaging, interactive, and accessible for buyers and renters."
              ghLink="https://github.com/Mouez-BELKAHLA/ReelState3"
              demoLink="https://reel-state3.vercel.app"
              videoLink="https://www.youtube.com/watch?v=71d2Kvchf64"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={mernecommerce}
              isBlog={false}
              title="MERN E-Commerce Website"
              description="A full-stack e-commerce site built with MongoDB, Express, React, and Node.js, covering product browsing, cart, and checkout flows."
              ghLink="https://github.com/Mouez-BELKAHLA/mern-ecommerce-website"
              demoLink=""
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={fashionecomerce}
              isBlog={false}
              title="Fashion E-Commerce Shop"
              description="A React + TypeScript fashion shopping app with product listings, cart, and checkout, built on a mock API backend."
              ghLink="https://github.com/Mouez-BELKAHLA/fashion-ecommerce-shop"
              demoLink=""
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;